import "./SinglePostTemplate.module.css"
import FraternalExcellenceHeader from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <FraternalExcellenceHeader />
      <SinglePostTemplateSection />
      <Footer />
    </div>
  )
}
